/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import request from '@/utils/http';

// 车牌
export const getLicensePlate = (data) => {
    return request({
        url: `/api-srm-web/basis/supplierCarInfos/getEnableCarListBySupplierCode`,
        method: 'post',
        data
    });
};
// 新车牌
export const getNewLicensePlate = data => {
    return request({
        url: `/api-tms/dispatch/resource/car/query`,
        method: 'post',
        data
    });
};

// 司机
export const getDriverName = (data) => {
    return request({
        url: `/api-srm-web/basis/supplierDriverInfo/getEnableDriverListBySupplierCode`,
        method: 'post',
        data
    });
};
// 新司机
export const getNewDriverName = data => {
    return request({
        url: `/api-tms/dispatch/resource/driver/query`,
        method: 'post',
        data
    });
};
// 白名单接口
export const getWhitelistList = () => {
    return request({
        url: `/api-opms/opms/whitelist/list?type=ON_WAY_CONTACT`,
        method: 'get'
    });
};

// 承运商
export const getSearchBySupplier = data => {
    return request({
        url: `/api-tms/srm/supplier/search`,
        method: 'post',
        data
    });
};
// 判断供应商是否直控运力
export const getIsControlTransportToOpt = (data) => {
    return request({
        url: `/api-tms/srm/getIsControlTransportToOpt`,
        method: 'post',
        data
    });
};

// 发运类型白名单接口
// 调车单号
export const getOrderNo = data => {
    return request({
        url: `api-tms/dispatch/ntp/order/list`,
        method: 'post',
        data
    });
};

// 新车牌接口，关联车型，采购渠道
export const getLicensePlateApi = data => {
    return request({
        url: `/api-tms/base/carInfo/page`,
        method: 'post',
        data
    });
};

// 会计主体
export const getInvoiceUnitName = (data) => {
    return request({
        url: `/api-dc/contract/info/matchContract`,
        method: 'post',
        data
    });
};
// 目标成本
export const getTargetCost = (data) => {
    return request({
        url: `/api-tms/dispatch/judgeCostSearch`,
        method: 'post',
        data
    });
};

// 白名单接口
export const getWhiteListApi = (params) => {
    return request({
        url: `/api-opms/opms/whitelist/list`,
        method: 'get',
        params
    });
};
// 白名单接口
export const isLingDanApi = (data) => {
    return request({
        url: `/api-tms/dispatch/isLingDan`,
        method: 'post',
        data
    });
};

export const isSiteWhiteListApi = (data) => {
    return request({
        url: `/api-tms/dispatch/reverse/process/whiteList/flag?siteCode=${data}`,
        method: 'get'
    });
};

// 根据承运商编码精准查询信息
export const searchBySupplierCodeOrNameCn = (params, tenantCode) => {
    return request({
        url: `/api-mdm/ebSupplier/selectBySupplierCode`,
        method: 'get',
        params,
        headers: {
            tenantCode
        }
    });
};

// 获取采购渠道
export const getProcurementChannelListApi = (data) => {
    return request({
        url: `/api-tms/srm/supplier/procurementChannel/query`,
        method: 'post',
        data
    });
};
// 判断装载率是否低于百分之50校验，通过就返回true
export const verifyLoadingRate = (data) => {
    return request({
        url: `/api-tms/dispatch/loadingRate/verify`,
        method: 'post',
        data
    });
};
// 查询快递单号校验
export const judgeExpressApi = (data) => {
    return request({
        url: `/api-tms/dispatch/judgeExpress`,
        method: 'post',
        data
    });
};
